import React, { useMemo } from 'react';
import { Table } from '@gerdau/hefesto-mais-web';
import { Title } from '@gerdau/hefesto';
import { IFabricationOrderAnnealedWire } from '../../../../../store/ducks/fabrication-orders/types';
import { TitleContainer, TableContainer } from '../styles';

interface IAnnealedWireContentProps {
  annealedWires: IFabricationOrderAnnealedWire[];
}

interface IAnnealedWireContentTableDataSource {
  key: number;
  description: string;
  percentage: string | number | undefined;
  weight: string | number | undefined;
}

const AnnealedWireContent: React.FC<IAnnealedWireContentProps> = ({
  annealedWires
}) => {
  const annelaedWireDataSourceProject: IAnnealedWireContentTableDataSource[] =
    useMemo(() => {
      return annealedWires.map(({ description, percentage, weight }, idx) => ({
        key: idx,
        description,
        percentage,
        weight
      }));
    }, [annealedWires]);

  const getColumns = () => {
    const columns = [
      {
        title: 'Tipo de arame',
        dataIndex: 'description',
        render: (description: string) => <>{description || '-'}</>
      },
      {
        title: 'Fornecer quantidade por:',
        dataIndex: 'percentage',
        render: (percentage: string) => <>{percentage || '-'}</>
      },
      {
        title: 'Peso do arame',
        dataIndex: 'weight',
        render: (weight: number, item: IAnnealedWireContentTableDataSource) => (
          <>
            {weight && !item.percentage
              ? `${weight} kg`
              : `${item.percentage}%`}
          </>
        )
      }
    ];

    return columns;
  };

  return (
    <>
      <TitleContainer>
        <Title level={2}>Arame recozido</Title>
      </TitleContainer>
      <TableContainer>
        <Table
          columns={getColumns()}
          dataSource={annelaedWireDataSourceProject}
        ></Table>
      </TableContainer>
    </>
  );
};

export default AnnealedWireContent;
